<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             :ok-text="$t('common.confirm')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.question-answer.QuestionAnswerItemCloseQuestionDialog.title') }}</template>

    <template #body>{{ $t('project.question-answer.QuestionAnswerItemCloseQuestionDialog.body') }}</template>
  </AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'QuestionAnswerItemCloseQuestionDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
